import gql from "graphql-tag";

export default gql`
  query SharesholdersHistory($tickerSymbol: TickerSymbol!) {
    sharesholdersHistory(tickerSymbol: $tickerSymbol) {
      asOfDate
      totalOfIndividualShareholders
      totalOfCorporateShareholders
      totalOfInstitutionalShareholders
      totalOfShareholders
    }
  }
`;
